module.exports = __webpack_public_path__ + "static/media/action-f.bbb4ce78.jpg";